module.exports = __webpack_public_path__ + "img/logo.54371b97.png";